import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import DocumentUpload from "./components/doc-upload-field/DocumentUpload";
import SuggestionInput from "./components/suggestion-input-field/SuggestionInput";
import { formatPhoneNumber } from "@/utils/phoneNumberFormatter";

const PurchaseProfileIndividualBusinessEntity = ({
  data,
  state,
  locationData,
  templateId,
  coBuyerDocRef,
  coBuyerFormRef,
  uploadedFiles,
  setUploadedFiles,
  setDocumentsId,
  handleCoBuyerFieldChange,
  coBuyerFormData,
  setCoBuyerFormData,
  coBuyerErrorValidate,
  setCoBuyerErrorValidate,
  IndividualCobuyer,
  setIndividualCobuyer,
}) => {
  const cmsData = data?.data;

  const purchaseProfileFormData = [
    {
      id: 0,
      label: "First Name",
      placeholder: "First Name",
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "firstName",
    },
    {
      id: 1,
      label: "Last Name",
      placeholder: "Last Name",
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "lastName",
    },
    {
      id: 2,
      label: "Middle Name",
      placeholder: "Middle Name",
      type: "text",
      required: false,
      editLink: false,
      formValueLabel: "middleName",
    },
    {
      id: 3,
      label: "Agency Name",
      placeholder: "Agency Name",
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "agencyName",
    },
    {
      id: 4,
      label: "Individual Address",
      placeholder: "Individual Address",
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "address1",
    },
    {
      id: 5,
      label: "Corporation Name",
      placeholder: "Corporation Name",
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "corporationName",
    },
    {
      id: 6,
      label: "Corporation Address",
      placeholder: "Corporation Address",
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "address1",
    },
    {
      id: 7,
      label: "State",
      placeholder: "State",
      type: "dropdown",
      required: true,
      editLink: false,
      formValueLabel: "state",
      options: [],
    },
    {
      id: 8,
      label: "City",
      placeholder: "City",
      type: "text",
      required: true,
      editLink: false,
      formValueLabel: "city",
      options: [],
    },
    {
      id: 9,
      label: "Zip Code",
      placeholder: "Zip Code",
      type: "number",
      required: true,
      editLink: false,
      formValueLabel: "zip",
    },
    {
      id: 10,
      label: "Email",
      placeholder: "Email",
      type: "email",
      required: true,
      editLink: true,
      formValueLabel: "emailId",
    },
    {
      id: 11,
      label: "Phone Number",
      placeholder: "Phone Number",
      type: "tel",
      required: true,
      editLink: false,
      formValueLabel: "phoneNumber",
    },
    {
      id: 12,
      label: "Upload Document",
      placeholder: "choose file",
      type: "file",
      required: false,
      editLink: false,
      accept: ".pdf,.doc",
      formValueLabel: "documentId",
    },
  ];

  const individualEntityField = [
    purchaseProfileFormData[0],
    purchaseProfileFormData[1],
    purchaseProfileFormData[2],
    purchaseProfileFormData[4],
    purchaseProfileFormData[7],
    purchaseProfileFormData[8],
    purchaseProfileFormData[9],
    purchaseProfileFormData[10],
    purchaseProfileFormData[11],
  ];

  const businessEntityField = [
    purchaseProfileFormData[0],
    purchaseProfileFormData[1],
    purchaseProfileFormData[2],
    purchaseProfileFormData[5],
    purchaseProfileFormData[12],
    purchaseProfileFormData[6],
    purchaseProfileFormData[7],
    purchaseProfileFormData[8],
    purchaseProfileFormData[9],
    purchaseProfileFormData[10],
    purchaseProfileFormData[11],
  ];

  const handleIndividualChange = (event) => {
    const value = event.target.value;
    setIndividualCobuyer(value);
    if (value === "IndividualCobuyer") {
      setUploadedFiles([]);
      setDocumentsId([]);
      setCoBuyerFormData((prev) => ({
        ...prev,
        corporationName: "",
      }));

      setCoBuyerErrorValidate((prev) => {
        const updatedErrors = { ...prev.errors };
        delete updatedErrors["corporationName"];
        return {
          isValid: Object.keys(updatedErrors).length === 0,
          errors: updatedErrors,
        };
      });
    }
  };

  return (
    <div className="mb-4">
      <Form>
        <Form.Group as={Row} className="mb-3">
          <Col sm="12" className="cobuyer-container">
            <Form.Label className="cobuyer-title">
              CO-BUYER'S INFORMATION
            </Form.Label>
            {/* <p>{cmsData?.coBuyerInformationHelpText}</p> */}
            <p className="pannel-accordian2-para" style={{ paddingLeft: 0 }}>
              As this profile information will be used to bind legal contract,
              please ensure to add information correctly. Missing information
              and/or inaccurate information can cause the contract to be
              rejected.
            </p>
          </Col>
          <Col sm="12">
            <p className="cobuyer-subtext-one">Is the co-buyer a(n)</p>
            <div style={{ display: "flex" }}>

              <Form.Check
                type="radio"
                id="individual-radio"
                label="Individual"
                name="IndividualCobuyer"
                value="IndividualCobuyer"
                checked={IndividualCobuyer === "IndividualCobuyer"}
                required
                style={{ marginRight: "1.5rem" }}
                onChange={handleIndividualChange}
                className="pp-responsive-font"
              />

              <Form.Check
                type="radio"
                id="business-radio"
                label="Business Entity"
                name="IndividualCobuyer"
                value="BusinessEntityCobuyer"
                checked={IndividualCobuyer === "BusinessEntityCobuyer"}
                required
                onChange={handleIndividualChange}
                 className="pp-responsive-font"
              />

            </div>
          </Col>
        </Form.Group>
        {IndividualCobuyer === "IndividualCobuyer" ? (
          <Row>
            {individualEntityField.map((item, index) => (
              <Col md={6} xs={12} key={index} className="g-4">
                <label
                  htmlFor={item.formValueLabel}
                  className="form-label pp-form-label"
                >
                  {item.label}
                  {item.required && <span className="text-danger">*</span>}
                </label>
                {item.type === "dropdown" ? (
                  <Form.Select
                    ref={(el) =>
                      (coBuyerFormRef.current[item.formValueLabel] = el)
                    }
                    className="form-select pp-responsive-font"
                    value={coBuyerFormData[item.formValueLabel] || ""}
                    name={item.formValueLabel}
                    id={item.formValueLabel}
                    required={item.required}
                    onChange={handleCoBuyerFieldChange}
                    style={{
                      padding: "12px",
                    }}
                  >
                    <option value="">{item.placeholder}</option>

                    {item.formValueLabel === "state"
                      ? // Render state options
                      (state || []).map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))
                      : null}
                  </Form.Select>
                ) : item.formValueLabel === "city" ? (
                  <SuggestionInput
                    inputRef={(el) =>
                      (coBuyerFormRef.current[item.formValueLabel] = el)
                    }
                    type={item.type}
                    formType="coBuyer"
                    setError={setCoBuyerErrorValidate}
                    placeholder={item.placeholder}
                    className="form-control pp-input-field"
                    value={coBuyerFormData[item.formValueLabel] || ""}
                    onChange={handleCoBuyerFieldChange}
                    name={item.formValueLabel}
                    id={item.formValueLabel}
                    required={item.required}
                    cityLoaded={locationData.coBuyer.loaded}
                    suggestions={locationData.coBuyer.cities || []}
                  />
                ) : (
                  <Form.Control
                    ref={(el) =>
                      (coBuyerFormRef.current[item.formValueLabel] = el)
                    }
                    type={item.type}
                    placeholder={item.placeholder}
                    value={
                      item.formValueLabel === "phoneNumber"
                        ? formatPhoneNumber(
                          coBuyerFormData[item.formValueLabel]
                        )
                        : coBuyerFormData[item.formValueLabel] || ""
                    }
                    onChange={handleCoBuyerFieldChange}
                    onBlur={handleCoBuyerFieldChange}
                    name={item.formValueLabel}
                    id={item.formValueLabel}
                    required={item.required}
                    className="form-control pp-responsive-font"
                  />
                )}
                {coBuyerErrorValidate &&
                  coBuyerErrorValidate[item.formValueLabel] && (
                    <div className="pp-error-message">
                      {coBuyerErrorValidate[item.formValueLabel]}
                    </div>
                  )}
              </Col>
            ))}
          </Row>
        ) : (
          <Row>
            {businessEntityField.map((item, index) => (
              <Col
                md={item.type === "file" ? 12 : 6}
                xs={12}
                key={index}
                className="g-4"
              >
                {item.type !== "file" && (
                  <label
                    htmlFor={item.formValueLabel}
                    className="form-label pp-form-label"
                  >
                    {item.label}
                    {item.required && <span className="text-danger">*</span>}
                  </label>
                )}

                {item.type === "dropdown" ? (
                  <Form.Select
                    ref={(el) =>
                      (coBuyerFormRef.current[item.formValueLabel] = el)
                    }
                    className="form-select pp-responsive-font"
                    value={coBuyerFormData[item.formValueLabel] || ""}
                    name={item.formValueLabel}
                    id={item.formValueLabel}
                    required={item.required}
                    onChange={handleCoBuyerFieldChange}
                    style={{
                      padding: "12px",
                    }}
                  >
                    <option value="">{item.placeholder}</option>

                    {item.formValueLabel === "state"
                      ? // Render state options
                      (state || []).map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))
                      : null}
                  </Form.Select>
                ) : item.type === "file" ? (
                  <DocumentUpload
                    isCoBuyer
                    docRef={coBuyerDocRef}
                    setDocumentId={setDocumentsId}
                    templateId={templateId}
                    buyerType={"LLC-cobuyer"}
                    uploadedFiles={uploadedFiles}
                    setUploadedFiles={setUploadedFiles}
                    setCoBuyerErrorValidate={setCoBuyerErrorValidate}
                  />
                ) : item.formValueLabel === "city" ? (
                  <SuggestionInput
                    inputRef={(el) =>
                      (coBuyerFormRef.current[item.formValueLabel] = el)
                    }
                    type={item.type}
                    formType="coBuyer"
                    setError={setCoBuyerErrorValidate}
                    placeholder={item.placeholder}
                    className="form-control pp-input-field"
                    value={coBuyerFormData[item.formValueLabel] || ""}
                    onChange={handleCoBuyerFieldChange}
                    name={item.formValueLabel}
                    id={item.formValueLabel}
                    required={item.required}
                    cityLoaded={locationData.coBuyer.loaded}
                    suggestions={locationData.coBuyer.cities || []}
                  />
                ) : (
                  <Form.Control
                    ref={(el) =>
                      (coBuyerFormRef.current[item.formValueLabel] = el)
                    }
                    type={item.type}
                    placeholder={item.placeholder}
                    value={
                      item.formValueLabel === "phoneNumber"
                        ? formatPhoneNumber(
                          coBuyerFormData[item.formValueLabel]
                        )
                        : coBuyerFormData[item.formValueLabel] || ""
                    }
                    onChange={handleCoBuyerFieldChange}
                    onBlur={handleCoBuyerFieldChange}
                    name={item.formValueLabel}
                    id={item.formValueLabel}
                    required={item.required}
                    className="form-control pp-responsive-font"
                  />
                )}
                {item.formValueLabel === "documentId"
                  ? coBuyerErrorValidate &&
                  coBuyerErrorValidate["coBuyerDocumentId"] && (
                    <div className="pp-error-message">
                      {coBuyerErrorValidate["coBuyerDocumentId"]}
                    </div>
                  )
                  : coBuyerErrorValidate &&
                  coBuyerErrorValidate[item.formValueLabel] && (
                    <div className="pp-error-message">
                      {coBuyerErrorValidate[item.formValueLabel]}
                    </div>
                  )}
              </Col>
            ))}
          </Row>
        )}
      </Form>
    </div>
  );
};

export default PurchaseProfileIndividualBusinessEntity;
